import "./footer.scss";

export default function footer() {
  return <div className="footer">
        <h3 className="copyright">Copyright &#x00040; {new Date().getFullYear()} </h3> 
  </div>;
}
